
const _ = require('lodash');


module.exports = function unwrap (x) {
	if (_.isFunction(x)) {
		return x();
	}
	return x;
	
};
